import { TweenMax, TimelineMax } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class SnowflakeOutro {
  private _arrowLeft: TweenMax;
  private _arrowRight: TweenMax;

  private _timeline1 = new TimelineMax();

  init ( ): void {
    this._arrowLeft = TweenMax.fromTo('#arrow-left-path', {
      y:-100,
      x:-1000
    }, {
      y:-100,
      x:200
    });
    this._arrowRight = TweenMax.fromTo('#arrow-right-path', {
      y:100,
      x:1000
    }, {
      y:100,
      x:-200
    });

    this._timeline1.add([this._arrowLeft, this._arrowRight]);

    ScrollTrigger.create({
      scrub: 1,
      animation: this._timeline1,
      trigger: '.outro-wrapper',
      start: 'top bottom'
    });
  }

  constructor ( ) { }
}
